import React from "react";
import { Route, Switch, NavLink } from "react-router-dom";
import ColorPicker from "components/colorPicker/ColorPicker";
import Platform1 from "./Platform1";
import Platform2 from "./Platform2";
import Platform3 from "./Platform3";
import "./LiveFeedIndex.scss";
import { useMeet } from "util/useMeet";
import map from "lodash/map";
import sortBy from "lodash/sortBy";
import NextOverlay from "./NextOverlay";
import CurrentOverlay from "./CurrentOverlay";
import classNames from "classnames";

const defaultChromaKeyColor = "#ffa500";
const chromaKeyColorStorageKey = "streaming-chroma-key";

const LiveFeedIndex = () => {
  const [fontColor, setFontColor] = React.useState<string | null | undefined>(
    "#FFFFFF"
  );
  const [backgroundColor, setBackgroundColor] = React.useState<
    string | null | undefined
  >(() => {
    try {
      const value = localStorage.getItem("streaming-chroma-key");
      return value || defaultChromaKeyColor;
    } catch (error) {
      return defaultChromaKeyColor;
    }
  });

  React.useEffect(() => {
    try {
      if (backgroundColor) {
        localStorage.setItem(chromaKeyColorStorageKey, backgroundColor);
      }
    } catch (error) {
      //
    }
  }, [backgroundColor]);

  const meet = useMeet();
  if (!meet) {
    return null;
  }

  const baseUrl = `/meets/${meet._id}`;

  const isDeprecated = window.location.pathname.includes("version");
  const isVersion3 = window.location.pathname.includes("version3");

  return (
    <div className="live-feed-index">
      <div className="tabs">
        <NavLink
          to={`${baseUrl}/liveFeed/current`}
          className="tab"
          activeClassName="active"
        >
          Current
        </NavLink>
        <NavLink
          to={`${baseUrl}/liveFeed/next`}
          className="tab"
          activeClassName="active"
        >
          Next
        </NavLink>
        <NavLink
          to={`${baseUrl}/liveFeed/version1`}
          className="tab"
          activeClassName="active"
        >
          V1 (Deprecated)
        </NavLink>
        <NavLink
          to={`${baseUrl}/liveFeed/version2`}
          className="tab"
          activeClassName="active"
        >
          V2 (Deprecated)
        </NavLink>
        <NavLink
          to={`${baseUrl}/liveFeed/version3`}
          className="tab"
          activeClassName="active"
        >
          V3 (Deprecated)
        </NavLink>
      </div>

      <div
        className="live-feed-content"
        style={{
          color: isDeprecated ? fontColor ?? undefined : undefined,
          backgroundColor: backgroundColor ?? undefined,
        }}
      >
        <div>
          {isDeprecated && (
            <div className="color-picker-wrapper">
              <label>Font Color: </label>
              <ColorPicker value={fontColor} onChange={setFontColor} />
            </div>
          )}
          <div className="color-picker-wrapper">
            <label>Chroma Key Color: </label>
            <ColorPicker
              value={backgroundColor}
              onChange={setBackgroundColor}
            />
          </div>
        </div>
        {!isVersion3 && (
          <div>Use theme controls in side navigation to customize</div>
        )}

        <div className={classNames(!isDeprecated && "live-feed-platforms")}>
          {map(sortBy(meet.platforms, ["name"]), (platform) => {
            return (
              <div key={platform._id}>
                <Switch>
                  <Route
                    path="/meets/:meetId/liveFeed/version1"
                    component={() => <Platform1 platformId={platform._id} />}
                  />
                  <Route
                    path="/meets/:meetId/liveFeed/version2"
                    component={() => <Platform2 platformId={platform._id} />}
                  />
                  <Route
                    path="/meets/:meetId/liveFeed/version3"
                    component={() => <Platform3 platformId={platform._id} />}
                  />
                  <Route
                    path="/meets/:meetId/liveFeed/current"
                    component={() => (
                      <CurrentOverlay platformId={platform._id} />
                    )}
                  />
                  <Route
                    path="/meets/:meetId/liveFeed/next"
                    component={() => <NextOverlay platformId={platform._id} />}
                  />
                  <Route
                    path="/meets/:meetId/liveFeed"
                    component={() => (
                      <CurrentOverlay platformId={platform._id} />
                    )}
                  />
                </Switch>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LiveFeedIndex;
